export default function CRTScreen({ tilt = -2.5, content = ":)", colorful = true }) {
  return (
    <div
      className={`motif-crt${!colorful ? " monochrome" : ""}`}
      style={{ transform: `rotate(${tilt}deg)` }}
    >
      <div className="screen">{content}</div>
    </div>
  );
}
